import React from 'react';

import {
  BlankLayout,
  CardLayout,
  LayoutType,
  PublicFullscreenLayout,
} from '@sandtech-hub-monorepo/ui-kit';
import { Footer } from '../app/Footer';
import { usePlatforms as getPlatforms } from '@sandtech-hub-monorepo/ui-kit-site';
import { FullscreenGuardedLayout } from './FullscreenGuardedLayout';

export const RouteWithLayout: React.FC<{
  layout: LayoutType;
  children: React.ReactNode;
}> = ({ layout, children }) => {
  const rootDomain = process.env['NX_COOKIE_DOMAIN'] || '';
  const { current } = getPlatforms(rootDomain);

  switch (layout) {
    case LayoutType.Fullscreen:
      return <FullscreenGuardedLayout current={current} children={children} />;
    case LayoutType.PublicFullscreen:
      return (
        <PublicFullscreenLayout
          children={children}
          footer={
            <div className="print:hidden">
              <Footer />
            </div>
          }
        />
      );
    case LayoutType.Card:
      // content-start (mobile only): without it, the grid's default
      // align-content shares h-screen's leftover space between the mobile
      // logo banner's row and the form's row, leaving a large gap after the
      // banner whenever the form itself is also short (e.g. ResetPassword).
      return (
        <CardLayout
          className="content-start lg:content-normal"
          children={children}
        />
      );
    default:
      return <BlankLayout children={children} />;
  }
};
